import * as React from "react";
import PropTypes from "prop-types";
import "./all.sass";
import PreviewCompatibleImage from "../components/PreviewCompatibleImage";
import { Link } from "gatsby";

var colourToggle=-1;

const FeatureGrid = ({ gridItems }) => (
  <div className="columns is-multiline">
    {gridItems.map((item) => {
    colourToggle*=-1;
    return (
      <div key={item.text} className="column is-4">
        <section className={colourToggle > 0?"feature-section-odd":"feature-section-even"}>
          <Link to={item.website} className="internal-link">
          <div className="parent">
          <div className="child">
            <p style={{marginBottom: "0"}} className="multiline-text">{item.text}</p>
            <div
              style={{
                width: "340px",
                display: "inline-block",
              }}
            >
              <PreviewCompatibleImage imageInfo={item} />
            </div>
          </div>
          </div>
          </Link>
        </section>
      </div>
    )})}
  </div>
);

FeatureGrid.propTypes = {
  gridItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      text: PropTypes.string,
      website: PropTypes.string,
    })
  ),
};

export default FeatureGrid;
